// 1PIF format:
//   { ...item JSON... }
//   ***5642bee8-a5ff-11dc-8314-0800200c9a66***
//   { ...item JSON... }
//   ***5642bee8-a5ff-11dc-8314-0800200c9a66***
//
// The separator line may or may not be the last line of the file.

export const ONEPIF_SEPARATOR = '***5642bee8-a5ff-11dc-8314-0800200c9a66***';

/**
 * Parse a .1pif file's text into an array of raw item objects.
 * Skips empty chunks. Throws on the first malformed JSON chunk so the
 * importer can show a precise error rather than silently dropping items.
 */
export function parse1pif(text) {
  if (typeof text !== 'string') throw new Error('parse1pif: expected string');

  const chunks = text.split(ONEPIF_SEPARATOR);
  const out = [];
  for (let i = 0; i < chunks.length; i++) {
    const chunk = chunks[i].trim();
    if (!chunk) continue;
    try {
      out.push(JSON.parse(chunk));
    } catch (err) {
      throw new Error(`parse1pif: invalid JSON in chunk #${i + 1}: ${err.message}`);
    }
  }
  return out;
}
